import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargePriceListItemResponse from "./chargePriceListItemResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargePriceListResponse {
  /**
   * Price list ID.
   */
  id!: string;

  /**
   * Price list name in default language.
   */
  @observable
  name!: string;

  /**
   * Beginning date of price list validity (included).
   */
  @observable
  @Type(() => Date)
  validSinceDate!: Date;

  /**
   * End date of price list validity (included).
   */
  @observable
  @Type(() => Date)
  validUntilDate?: Date;

  /**
   * The IDs of included charge types.
   */
  @observable
  includedChargeTypeIds!: string[];

  /**
   * The IDs of included fuel types.
   */
  @observable
  includedFuelTypeIds!: string[];

  /**
   * The list of price list items - prices for all combinations of included charge types and fuel types.
   */
  @observable
  @Type(() => ChargePriceListItemResponse)
  items!: ChargePriceListItemResponse[];
}
